export default __webpack_public_path__ + "static/socials-dfdcbccdef3cb5aa2d4b37b4d7cd1ea3.png";